import React, { useState, useEffect, Fragment, useRef } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box, Card, Grid, TextField, makeStyles, Container, Button, CardContent, Divider, InputLabel, CardHeader, MenuItem,
  Table, Paper, TablePagination,
} from '@material-ui/core';
import Page from 'src/components/Page';
import services from '../Services';
import { trackPromise } from 'react-promise-tracker';
import { Formik, validateYupSchema } from 'formik';
import * as Yup from "yup";
import authService from '../../../../utils/permissionAuth';
import tokenService from '../../../../utils/tokenDecoder';
import { useNavigate } from 'react-router-dom';
import MaterialTable from "material-table";
import TableContainer from '@material-ui/core/TableContainer';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableBody from '@material-ui/core/TableBody';
import { DatePicker, MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import moment from 'moment';
import xlsx from 'json-as-xlsx';
import ReactToPrint from "react-to-print";
import CreatePDF from './CreatePDF';
import {
  endOfMonth,
} from 'date-fns';
import { useAlert } from 'react-alert';


const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  colorCancel: {
    backgroundColor: "red",
  },
  colorRecord: {
    backgroundColor: "green",
  },

}));

const screenCode = 'CHEQUECUSTOMERREPORT';

export default function ChequeCustomerReport(props) {
  const today = new Date();
  const [balancePaymentYearMonth, setBalancePaymentYearMonth] = useState();
  const [title, setTitle] = useState("Cheque Customer Report");
  const classes = useStyles();
  const [chequeCustomerDetail, setChequeCustomerDetail] = useState({
    groupID: 0,
    factoryID: 0,
    routeID: 0,
    year: '',
    month: ''
  });
  const [FactoryList, setFactoryList] = useState([]);
  const [GroupList, setGroupList] = useState([]);
  const [routes, setRoutes] = useState();
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedDatePDF, setSelectedDatePDF] = useState();
  const [chequeCustomerData, setChequeCustomerData] = useState([]);
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false,
  });
  const navigate = useNavigate();

  const [csvHeaders, SetCsvHeaders] = useState([])
  const [csvData, setCsvData] = useState([]);
  const [selectedSearchValues, setSelectedSearchValues] = useState({
    groupName: "0",
    factoryName: "0",
    routeName: '',
    monthName: '',
    year: '',
    monthName: ''

  })
  const componentRef = useRef();
  const [totalAmount, setTotalAmount] = useState(0);
  const [maxDate, setMaxDate] = useState(new Date());
  const [searchStarted, setSearchStarted] = useState(false);
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const alert = useAlert();
  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };
  const handleLimitChange = (event) => {
    setLimit(event.target.value);
  };

  useEffect(() => {
    trackPromise(
      getPermission()
    );
    trackPromise(
      getGroupsForDropdown(),
    );
  }, []);

  useEffect(() => {
    getFactoriesForDropdown();
  }, [chequeCustomerDetail.groupID]);

  useEffect(() => {
    trackPromise(
      getRoutesByFactoryID()
    )
  }, [chequeCustomerDetail.factoryID]);

  useEffect(() => {
    trackPromise(
      checkISBalancePaymentCompleted()
    )
  }, [chequeCustomerDetail.groupID, chequeCustomerDetail.factoryID]);

  useEffect(() => {
    if (chequeCustomerDetail.factoryID > 0 && chequeCustomerDetail.groupID > 0) {
      trackPromise(GetBalancePaymentYearMonthForDropDown());
    }
  }, [chequeCustomerDetail.factoryID, chequeCustomerDetail.groupID]);

  async function getPermission() {
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWCHEQUECUSTOMERREPORT');

    if (isAuthorized === undefined) {
      navigate('/404');
    }
    var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
    var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
    });

    setChequeCustomerDetail({
      ...chequeCustomerDetail,
      groupID: parseInt(tokenService.getGroupIDFromToken()),
      factoryID: parseInt(tokenService.getFactoryIDFromToken())
    })
  }

  async function getGroupsForDropdown() {
    const groups = await services.getAllGroups();
    setGroupList(groups);
  }

  async function getFactoriesForDropdown() {
    const factories = await services.getFactoryByGroupID(chequeCustomerDetail.groupID);
    setFactoryList(factories);
  }

  async function getRoutesByFactoryID() {
    const routeList = await services.getRoutesForDropDown(chequeCustomerDetail.factoryID);
    setRoutes(routeList);
  }

  async function checkISBalancePaymentCompleted() {

    const response = await services.CheckISBalancePaymentCompleted(chequeCustomerDetail.groupID, chequeCustomerDetail.factoryID);
    const bDate = moment(response.data.lastBalancePaymentSchedule, moment.defaultFormat).toDate();
    var result = endOfMonth(bDate);

    setMaxDate(result);
  }

  async function GetBalancePaymentYearMonthForDropDown() {
    try {
      var response = await services.GetBalancePaymentYearMonth(chequeCustomerDetail.groupID, chequeCustomerDetail.factoryID);
      const applicableYear = parseInt(response.applicableYear);
      const applicableMonth = parseInt(response.applicableMonth) - 1;

      const selectedDate = new Date(applicableYear, applicableMonth);

      setSelectedDate(selectedDate);
      setSelectedDatePDF(response);
    } catch (error) {
      console.error("Error fetching balance payment year and month:", error);
    }
  };

  async function GetDetails() {
    let total = 0;

    const applicableYear = selectedDate.getFullYear().toString();
    const applicableMonth = (selectedDate.getMonth() + 1).toString();

    let model = {
      groupID: parseInt(chequeCustomerDetail.groupID),
      factoryID: parseInt(chequeCustomerDetail.factoryID),
      routeID: parseInt(chequeCustomerDetail.routeID),
      applicableMonth: applicableMonth,
      applicableYear: applicableYear
    }

    getSelectedDropdownValuesForReport(model);

    const customerData = await services.GetChequeCustomerDetails(model);

    if (customerData.statusCode == "Success" && customerData.data != null) {
      setChequeCustomerData(customerData.data);
      customerData.data.forEach(x => {
        total = total + parseFloat(x.amount)
      });
      if (customerData.data.length == 0) {
        alert.error("NO RECORDS TO DISPLAY");
      } else {
        alert.success("Success");
      }
      setTotalAmount(total);
      createDataForExcel(customerData.data);
    }
    else {
      alert.error("Error");
    }
  }

  async function createDataForExcel(array) {
    var res = [];

    if (array != null) {
      array.map(x => {
        var vr = {
          'Route Name': x.routeName,
          'Reg No': x.registrationNumber,
          'Customer Name': x.name,
          'Amount (Rs)': x.amount,
        }
        res.push(vr);
      });
      var vr = {
        'Route Name': "Total",
        'Reg No': "",
        'Customer Name': "",
        'Amount (Rs)': totalAmount,
      }
      res.push(vr);
      res.push({});

      var vr = {
        'Route Name': "Group: " + selectedSearchValues.groupName,
        'Reg No': "Factory: " + selectedSearchValues.factoryName,
      }
      res.push(vr);
      var vr = {
        'Route Name': "Route: " + (selectedSearchValues.routeName === undefined ? "All Routes" : selectedSearchValues.routeName),
      }
      res.push(vr);
      var vr = {
        'Route Name': "Year and month: " + selectedSearchValues.monthName + " " + selectedSearchValues.year,
      }
      res.push(vr);
    }
    return res;
  }

  async function createFile() {

    var file = await createDataForExcel(chequeCustomerData);
    var settings = {
      sheetName: 'Cheque Customer Details Report',
      fileName: 'Cheque Customer Details Report - ' + 
        selectedSearchValues.groupName + " - " + 
        selectedSearchValues.factoryName + " - " +
        (selectedSearchValues.routeName === undefined ? "All Routes":selectedSearchValues.routeName) + " - " +
        selectedSearchValues.monthName + " " + selectedSearchValues.year,
      writeOptions: {}
    }

    let keys = Object.keys(file[0])
    let tempcsvHeaders = csvHeaders;
    keys.map((sitem, i) => {
      tempcsvHeaders.push({ label: sitem, value: sitem })
    })

    let dataA = [
      {
        sheet: 'Cheque Customer Details Report',
        columns: tempcsvHeaders,
        content: file
      }
    ]
    xlsx(dataA, settings);
  }

  function generateDropDownMenu(data) {
    let items = []
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
      }
    }
    return items;
  }

  function handleChange(e) {
    const target = e.target;
    const value = target.value
    setChequeCustomerDetail({
      ...chequeCustomerDetail,
      [e.target.name]: value
    });
    setChequeCustomerData([]);
  }

  function handleDateChange(date) {
    let monthNames = ["JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE", "JULY", "AUGUST", "SEPTEMBER", "OCTOMBER", "NOVEMBER", "DECEMBER"];
    var month = date.getUTCMonth() + 1;
    var year = date.getUTCFullYear();
    setChequeCustomerDetail({
      ...chequeCustomerDetail,
      month: month.toString(),
      year: year.toString()
    });

    if (selectedDate != null) {

      var prevMonth = selectedDate.getUTCMonth() + 1
      var prevyear = selectedDate.getUTCFullYear();

      if ((prevyear == year && prevMonth != month) || (prevyear != year)) {
        setSelectedDate(date)
        setSearchStarted(true)
      }
    } else {
      setSelectedDate(date)
      setSearchStarted(true)
    }
    setChequeCustomerData([]);
  }

  function getSelectedDropdownValuesForReport(searchForm) {
    let monthNames = ["JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE", "JULY", "AUGUST", "SEPTEMBER", "OCTOMBER", "NOVEMBER", "DECEMBER"];
    let selectedMonth = monthNames[(parseInt(searchForm.applicableMonth))- 1];
    setSelectedSearchValues({
      ...selectedSearchValues,
      groupName: GroupList[searchForm.groupID],
      factoryName: FactoryList[searchForm.factoryID],
      routeName : routes [searchForm.routeID],
      year: parseInt(searchForm.applicableYear),
      monthName: selectedMonth
    })
  }

  function cardTitle(titleName) {
    return (
      <Grid container spacing={1}>
        <Grid item md={10} xs={12}>
          {titleName}
        </Grid>
      </Grid>
    )
  }

  const getPageMargins = () => {
    return `@media print {
        @page {
            background-color: white !important;
        }
   
        body {
            background-color: white !important;
        }
    }`;
  };

  return (
    <Fragment>
      <Page className={classes.root} title={title}>
        <Container maxWidth={false}>
          <Formik
            initialValues={{
              groupID: chequeCustomerDetail.groupID,
              factoryID: chequeCustomerDetail.factoryID
            }}
            validationSchema={
              Yup.object().shape({
                groupID: Yup.number().required('Group required').min("1", 'Group required'),
                factoryID: Yup.number().required('Factory required').min("1", 'Factory required'),
              })
            }
            enableReinitialize
          >
            {({
              errors,
              handleBlur,
              handleSubmit,
              touched
            }) => (
              <form onSubmit={handleSubmit}>
                <Box mt={0}>
                  <Card>
                    <CardHeader
                      title={cardTitle(title)}
                    />
                    <PerfectScrollbar>
                      <Divider />
                      <CardContent>
                        <Grid container spacing={3}>
                          <Grid item md={3} xs={8}>
                            <InputLabel shrink id="groupID">
                              Group *
                            </InputLabel>
                            <TextField select
                              error={Boolean(touched.groupID && errors.groupID)}
                              fullWidth
                              helperText={touched.groupID && errors.groupID}
                              name="groupID"
                              onBlur={handleBlur}
                              onChange={(e) => handleChange(e)}
                              value={chequeCustomerDetail.groupID}
                              variant="outlined"
                              id="groupID"
                              disabled={!permissionList.isGroupFilterEnabled}
                              size='small'
                            >
                              <MenuItem value="0">--Select Group--</MenuItem>
                              {generateDropDownMenu(GroupList)}
                            </TextField>
                          </Grid>

                          <Grid item md={3} xs={8}>
                            <InputLabel shrink id="factoryID">
                              Factory *
                            </InputLabel>
                            <TextField select
                              error={Boolean(touched.factoryID && errors.factoryID)}
                              fullWidth
                              helperText={touched.factoryID && errors.factoryID}
                              name="factoryID"
                              onBlur={handleBlur}
                              onChange={(e) => handleChange(e)}
                              value={chequeCustomerDetail.factoryID}
                              variant="outlined"
                              id="factoryID"
                              disabled={!permissionList.isFactoryFilterEnabled}
                              size='small'
                            >
                              <MenuItem value="0">--Select Factory--</MenuItem>
                              {generateDropDownMenu(FactoryList)}
                            </TextField>
                          </Grid>

                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="routeID">
                              Route
                            </InputLabel>
                            <TextField select
                              fullWidth
                              name="routeID"
                              onChange={(e) => handleChange(e)}
                              value={chequeCustomerDetail.routeID}
                              variant="outlined"
                              id="routeID"
                              size='small'
                            >
                              <MenuItem value="0">--Select Route--</MenuItem>
                              {generateDropDownMenu(routes)}
                            </TextField>
                          </Grid>

                          <Grid item md={3} xs={12}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                              <DatePicker
                                autoOk
                                variant="inline"
                                openTo="month"
                                views={["year", "month"]}
                                label="Year and Month *"
                                value={selectedDate}
                                maxDate={maxDate}
                                onChange={(date) => handleDateChange(date)}
                              />
                            </MuiPickersUtilsProvider>
                          </Grid>
                        </Grid>
                        <Grid container justify="flex-end">
                          <Box pt={2}>
                            <Button
                              color="primary"
                              variant="contained"
                              type='submit'
                              onClick={() => trackPromise(GetDetails())}
                            >
                              Search
                            </Button>
                          </Box>
                        </Grid>
                      </CardContent>

                      {chequeCustomerData.length > 0 ?
                      <Box minWidth={1050} style={{ padding: "10px" }}>
                        <TableContainer component={Paper}>
                          <Table className={classes.table} aria-label="simple table">

                            <TableHead>
                              <TableRow style={{ border: "2px solid black" }}>
                                <TableCell align="left" style={{ fontWeight: "bold", border: "2px solid black", fontSize: '16px' , width: '20%' }}>Route Name</TableCell>
                                <TableCell align="left" style={{ fontWeight: "bold", border: "2px solid black", fontSize: '16px' , width: '20%'}}>Reg No</TableCell>
                                <TableCell align="left" style={{ fontWeight: "bold", border: "2px solid black", fontSize: '16px' , width: '20%'}}>Customer Name</TableCell>
                                <TableCell align="right" style={{ fontWeight: "bold", border: "2px solid black", fontSize: '16px' , width: '20%', paddingRight: '2%'}}>Amount (Rs)</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                            {chequeCustomerData.slice(page * limit, page * limit + limit).map((row, i) => (
                                    <TableRow style={{ border: "2px solid black" }} key={i}>
                                      <TableCell component="th" scope="row" align="left" style={{ border: "2px solid black" , width: '20%'}}> {row.routeName}</TableCell>
                                      <TableCell component="th" scope="row" align="left" style={{ border: "2px solid black" , width: '20%'}}> {row.registrationNumber}</TableCell>
                                      <TableCell component="th" scope="row" align="left" style={{ border: "2px solid black" , width: '20%'}}> {row.name}</TableCell>
                                      <TableCell component="th" scope="row" align="right" style={{ border: "2px solid black" , width: '20%', paddingRight: '2%'}}> {row.amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell> 
                                    </TableRow>
                                  ))}
                                  <TableRow style={{ border: "2px solid black" }}>
                                      <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black", fontSize: '16px' , width: '20%' }} colSpan={3}>Total</TableCell>
                                      <TableCell align="right" style={{ fontWeight: "bold", border: "2px solid black", fontSize: '16px' , width: '20%', paddingRight: '2%'}}>{totalAmount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                    </TableRow>
                            </TableBody>
                          </Table>
                          <TablePagination
                                component="div"
                                count={chequeCustomerData.length}
                                onChangePage={handlePageChange}
                                onChangeRowsPerPage={handleLimitChange}
                                page={page}
                                rowsPerPage={limit}
                                rowsPerPageOptions={[5, 10, 25]}
                              />
                        </TableContainer>
                      </Box> : null }
                        
                      {chequeCustomerData.length > 0 ?
                        <Box display="flex" justifyContent="flex-end" p={2}>
                          <Button
                            color="primary"
                            id="btnRecord"
                            type="submit"
                            variant="contained"
                            style={{ marginRight: '1rem' }}
                            className={classes.colorRecord}
                            onClick={createFile}
                            size='small'
                          >
                            EXCEL
                          </Button>
                          <ReactToPrint
                            documentTitle={"Cheque Customer Details Report" + " - " + 
                              selectedSearchValues.groupName + " - " + 
                              selectedSearchValues.factoryName + " - " +
                              (selectedSearchValues.routeName === undefined ? "All Routes":selectedSearchValues.routeName) + " - " +
                              selectedSearchValues.monthName + " " + selectedSearchValues.year}
                            trigger={() => <Button
                              color="primary"
                              id="btnRecord"
                              type="submit"
                              variant="contained"
                              style={{ marginRight: '1rem' }}
                              className={classes.colorCancel}
                              size='small'
                            >
                              PDF
                            </Button>}
                            pageStyle={getPageMargins()}
                            content={() => componentRef.current}
                          />
                          <div hidden={true}>
                            <CreatePDF ref={componentRef}
                              searchData={selectedSearchValues} searchDate={chequeCustomerDetail} chequeCustomerData={chequeCustomerData}
                              total={totalAmount} selectedDatePDF={selectedDatePDF}
                            />
                          </div>
                        </Box> : null}
                    </PerfectScrollbar>
                  </Card>
                </Box>
              </form>
            )}
          </Formik>
        </Container>
      </Page>
    </Fragment>
  );
}
